// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"adc2dd85","479":"b2fab3e9","485":"a7bc7cd0","531":"5dbff15d","915":"d739465c","949":"fc8607e7"}[chunkId] + ".chunk.js";
};